import * as preact from "preact";

import * as impersonation from "impersonation";

const MINUTE = 60 * 1000;

const minutesLeft = (expiresAt: number) =>
  Math.max(0, Math.ceil((expiresAt - Date.now()) / MINUTE));

/**
 * Always-visible reminder that this session is borrowing someone else's
 * identity, with the way out. Rendered by AppRootView on every page, including
 * those without the site header.
 */
export default class ImpersonationBannerView extends preact.Component {
  private timer?: ReturnType<typeof setInterval>;

  componentDidMount() {
    // Keeps the countdown honest; the identity itself comes from the signal.
    this.timer = setInterval(() => this.forceUpdate(), 10000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const info = impersonation.info.value;
    if (!info) {
      return null;
    }

    const remaining = minutesLeft(info.expiresAt);

    return (
      <div class="impersonationBanner">
        <span>
          Impersonating <strong>{info.targetEmail}</strong> ·{" "}
          {remaining > 0 ? `${remaining} min left` : "expired"}
        </span>
        <button onClick={() => impersonation.exit()}>
          Exit &amp; sign out
        </button>
      </div>
    );
  }
}
